module.exports = __webpack_public_path__ + "src/assets/img/geo-green.2b207c2b.svg";